import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, labelModes, services } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderSumField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.sum,
        label: this.getTranslate(`${services.payments}.labels.sum`),
        hint: this.getTranslate(`${services.payments}.hints.sum`),
        suffix: this.commission,
        type: 'number',
        step: 1,
        min: 0,
        labelMode: labelModes.outline,
        required: true,
        clearable: true,
        autofocus: true,
        details: true
      },
      on: {
        input: event => {
          this.sum = event
        }
      }
    }
  )
}

function renderHiddenFields(h) {
  return Object.keys(this.payload).map(field => {
    return h(
      'input',
      {
        attrs: {
          hidden: true,
          value: this.payload[field],
          name: field
        }
      }
    )
  })
}

function renderInfo(h) {
  return h(
    'div',
    {
      class: 'yooMoney-info'
    },
    [
      h(
        info,
        {
          props: {
            value: this.getTranslate(`${services.payments}.warnings.yooMoney`, {
              username: this.account.username,
              sum: this.sum
            }),
            color: Colors.warning
          }
        }
      )
    ]
  )
}

function renderCheckbox(h) {
  return h(
    components.checkbox,
    {
      props: {
        value: this.acknowledged,
        label: this.getTranslate(`${services.payments}.labels.acknowledged`),
        outline: true
      },
      on: {
        input: event => {
          this.acknowledged = event
        }
      }
    }
  )
}

function renderRequestButton(h) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.filled,
        color: Colors.primary,
        label: this.getTranslate('misc.buttons.pay'),
        disabled: !this.validation,
        type: 'submit'
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe'
    },
    [ renderRequestButton.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'form',
    {
      class: 'yooMoney-form',
      attrs: {
        action: 'https://yoomoney.ru/quickpay/confirm.xml',
        method: 'post'
      }
    },
    [
      renderHiddenFields.call(this, h),
      renderSumField.call(this, h),
      renderInfo.call(this, h),
      renderCheckbox.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
